/**
 * Access control for the `salesRep` role.
 *
 * All lists here are ADDITIVE allow-lists: they only ever grant access to the
 * salesRep role, so extending them can never change what any other role sees.
 * Keep the sidebar links, sidebar sections, and routes below in sync when the
 * salesRep permission set changes.
 */

export const SALES_REP_ROLE = "salesrep";

/**
 * Route paths salesRep may access, in addition to the universal ("*") routes
 * (Dashboard, Profile, Change Password, Email Notifications).
 * Includes order-detail patterns so a rep can open an order from a list.
 */
export const SALES_REP_ROUTE_PATHS: ReadonlySet<string> = new Set([
  "/customers",
  "/all-orders",
  "/all-orders/:id",
  "/active-order",
  "/active-order/:id",
  "/delivered-order",
  "/delivered-order/:id",
  "/finalized-order",
  "/finalized-order/:id",
  "/cancelled-order",
  "/cancelled-order/:id",
  "/invoiced-order",
  "/invoiced-order/:id",
  "/dispatch-board-list",
]);
